import { openDecagonChat, prepopulateDecagonMessage } from 'components/Decagon';

import { messages } from '../Services.messages';

// When payout isn't available, the backend has no percentage/amount to base a
// source on, so both must go out as null rather than a stale/default guess.
export const resolveCalculatedPayout = ({
  payout_available: payoutAvailable,
  payout,
  payout_percentage: payoutPercentage,
  payout_percentage_source: payoutPercentageSource,
}) => {
  const { currency_code: payoutCurrencyCode, currency_units: rawPayoutCurrencyUnits } = payout ?? {};
  if (!payoutAvailable) {
    return { payoutCurrencyCode, payoutCurrencyUnits: null, payoutPercentage, payoutPercentageSource: null };
  }

  return {
    payoutCurrencyCode,
    payoutCurrencyUnits: Number(rawPayoutCurrencyUnits),
    payoutPercentage,
    payoutPercentageSource,
  };
};

export function openPricingSupportChat(intl, { serviceName, serviceId, venueId }) {
  openDecagonChat();
  prepopulateDecagonMessage(intl.formatMessage(messages.form.pricingQuestion, { serviceName, serviceId, venueId }));
}
